import PropTypes from 'prop-types'

export const inputShape = PropTypes.shape({
  error: PropTypes.string,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  value: PropTypes.any
})

export const selectFieldShape = PropTypes.shape({
  errorText: PropTypes.string,
  input: PropTypes.object.isRequired,
  source: PropTypes.shape({
    data: PropTypes.array,
    error: PropTypes.object,
    loading: PropTypes.bool
  }).isRequired
})

export const sourceShape = PropTypes.shape({
  data: PropTypes.array,
  error: PropTypes.object,
  loading: PropTypes.bool
})
